import { Box, Grid, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { CollapsibleTable, CollapsibleTableCell } from "../../components/CollapsibleTable";
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from "../../components/ScrollIndicatorsComp/ScrollIndicatorsComp";
import useVerticalScroll from "../../utils/hooks/useVerticalScroll";
import { ButtonItem, ButtonType, IButtonData } from "./ButtonsData";
import { buttonsTypeDataAutomation } from "./ButtonsModels";
import { asteriskStyle, containerFixedStyle, containerStyle, dropdownStyle, lastUpdateCaptionStyle, selectStyle } from "./styled";

interface IButtonsProps {
  data: IButtonData;
  handleChangeButtonType: (event: SelectChangeEvent<ButtonType>) => void;
  handleButtonClick: (button: ButtonItem, url: string) => void;
}

export const Buttons: React.FC<IButtonsProps> = ({
  data,
  handleChangeButtonType,
  handleButtonClick
}) => {
  const { type } = useParams();
  const dropDownsFixedAtTop = useVerticalScroll();
  const buttonUpdate = data.buttonUpdate
  const buttonType = data.category;
  let selectedButtonType: any;
  let buttonSubUrl = '';
  switch (buttonType) {
    case "union": {
      selectedButtonType = ButtonType.union;
      buttonSubUrl = 'union-board';
      break;
    }
    case "sur": {
      selectedButtonType = ButtonType.sur;
      buttonSubUrl = 'union-board';
      break;
    }
    case "casual": {
      selectedButtonType = ButtonType.casual;
      buttonSubUrl = 'casual-board';
      break;
    }
    case "tel": {
      selectedButtonType = ButtonType.tel;
      buttonSubUrl = 'telephone-board';
      break;
    }
    case undefined: {
      selectedButtonType = ButtonType[type as keyof typeof ButtonType];
      break;
    }
  };

  const buttonInfo = data.buttons?.map((button) => {
    const { buttonImage, buttonDescription, plateNumber, boardDescription } = button;
    return {
      buttonImage:
        <img
          src={`/assets/images/buttons/${buttonImage}`}
          alt={buttonImage}
          style={{ border: "#000000 1px solid", cursor: 'pointer' }}
          onClick={() => handleButtonClick(button, buttonSubUrl)}
        />,
      buttonDescription,
      boardDescription,
      plateNumber
    }
  }) || [];

  const cols: CollapsibleTableCell[] = ['', 'Description', 'Board', 'Plate'].map((title) => ({ title, align: "left" }));
  return (
    <MainContainer hasGreyBg>
      <Grid container spacing={2} sx={dropDownsFixedAtTop ? { ...containerStyle, ...containerFixedStyle } : containerStyle}>
        <Grid item xs={0} sm={2} lg={3.5} />
        <Grid item xs={12} sm={8} lg={5} sx={dropdownStyle}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography sx={{ textWrap: 'nowrap', pr: 1 }} data-automation="button-type-lbl">
              Button Type<Typography component={"span"} sx={asteriskStyle}>&nbsp;*</Typography>
            </Typography>
            <Select
              className="small"
              data-automation="button-type-dropdown"
              sx={selectStyle}
              value={selectedButtonType}
              onChange={handleChangeButtonType}
            >
              {Object.values(ButtonType).map((buttonType) => (
                <MenuItem data-automation={buttonsTypeDataAutomation[buttonType]} key={buttonType} value={buttonType}>
                  {buttonType}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>
        <Grid item xs={0} sm={2} lg={3.5} />
      </Grid>
      {buttonUpdate &&
        <Typography sx={lastUpdateCaptionStyle} data-automation="buttons-last-update-lbl">
          Last Update: {buttonUpdate}
        </Typography>
      }
      <Typography
        component={'div'}
        variant='container'
        data-automation="data-container"
      >
        <ScrollIndicatorsComp>
          <CollapsibleTable
            sxSmall={true}
            cols={cols}
            rows={buttonInfo}
            isOneLevel
            dataAutomation={{
              header: "buttons-tbl-header",
              columns: [
                "buttons-img",
                "buttons-desc",
                "buttons-board",
                "buttons-plate"
              ].map(x => `${x} buttons-tbl-head-cell`),
              rows: "buttons-tbl-row"
            }}
          />
        </ScrollIndicatorsComp>
      </Typography>
    </MainContainer>
  )
}

export { ButtonType };

